

import React from 'react';
import { FILTER_CHANGED} from 'utils/constants';

class Filters extends React.Component{
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.getCurrentFilter = this.getCurrentFilter.bind(this);
        let ev = {};
        app.events.subscribe(ev,this);
        this.state = {currentFilter: this.getCurrentFilter()}
    }
    getCurrentFilter(){
        let returnFilter = {}
        let {children, currentFilter} = this.props; 
        if(children && !children.length && currentFilter && currentFilter.f.length) returnFilter['filter'] = currentFilter.f
        else if(children && children.length >0 && currentFilter && currentFilter.f.length) {
            children.map((fitem, index)=>{
                let fieldUniqkey = 'filter'+index
                let itemFromCurrentFilter = currentFilter.f.find(item=>item.field == fitem.props.field)
                if(itemFromCurrentFilter) returnFilter[fieldUniqkey] = itemFromCurrentFilter
                // return React.cloneElement(item, { onChange: this.onChange, fieldUniqkey:'filter'+index, key:'filter'+index })
            })
        } 
        return returnFilter;
    }
    onChange([fieldKey, fieldValue, fieldUniqkey]){
        let currentFilter = {...this.state.currentFilter};

        // const fields = currentFilter[fieldUniqkey] || {field:fieldKey, codes:[]};
        const filterObj = {field:fieldKey, codes:[]};
        if(["name", "group_name"].includes(filterObj.field)) filterObj.operator = "contains";        
       
        if(Array.isArray(fieldValue)){
            filterObj.codes = fieldValue;
        }else {
            filterObj.codes = fieldValue?[fieldValue]:[];           
        } 
        currentFilter[fieldUniqkey] = filterObj; 

        //TODO for multiple filters, iterate through currentFilter fieldkeys 
        let updatedFilter = [];//[currentFilter[fieldKey]];
        for(let [filterKey, filterData] of Object.entries(currentFilter)){
        	if(filterData.codes.length > 0)updatedFilter.push(filterData);
        }
        this.setState({currentFilter})
        app.events.trigger(FILTER_CHANGED, {f: updatedFilter});
        if(this.props.filterChanged)this.props.filterChanged({f: updatedFilter})
    }

    render(){
        let {children, clsNames} = this.props;
        return(
            <div className={"filters-wrapper "+(clsNames || '')}>
                {/* {this.state.filters.map((filter,i)=> 
                    <Filter  />)} */}
                {/* {this.props.children} */}
                {children && !children.length &&
                    React.cloneElement(children, { onChange: this.onChange, fieldUniqkey:'filter', key:'filter' })
                }
                {children && children.length >0 && 
                    children.map((item, index)=>{
                        return React.cloneElement(item, { onChange: this.onChange, fieldUniqkey:'filter'+index, key:'filter'+index })
                    })
                }
                {/* {React.cloneElement(this.props.children, { onChange: this.onChange })} */}
                        
            </div>
        )
    }
}
export default Filters;
